import { render, staticRenderFns } from "./RpdCriteriaExclusions.vue?vue&type=template&id=139cd12f"
import script from "./RpdCriteriaExclusions.vue?vue&type=script&lang=js"
export * from "./RpdCriteriaExclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports